<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>账单编号：</p>
        <el-input v-model="numIpt" size="mini" style="width:150px" placeholder="请输入账单编号"/>
      </div>
      <div class="navContainer">
        <p>标题：</p>
        <el-input v-model="titleIpt" size="mini" style="width:150px" placeholder="请输入标题"/>
      </div>
      <div class="navContainer" style="width: 480px">
        <p>对账时间：</p>
        <el-date-picker
          v-model="timeIpt"
          size="mini"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"/>
      </div>
      <div class="navContainer" style="width: 500px">
        <p>审核通过时间：</p>
        <el-date-picker
          v-model="auditTimeIpt"
          size="mini"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>开票状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>收款状态：</p>
        <el-select v-model="payStateIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in payStateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="num" label="账单编号" align="center"/>
          <el-table-column prop="title" label="标题" align="center"/>
          <el-table-column prop="type" label="收付类型" width="199" align="center"/>
          <el-table-column prop="receipts" label="收付方" align="center"/>
          <el-table-column prop="total" label="合计金额" align="center"/>
          <el-table-column prop="time" label="申请时间" align="center"/>
          <el-table-column prop="state" label="审核状态" align="center"/>
          <el-table-column label="操作" width="205" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.$index, scope.row)">详情</el-button>
                <el-button v-if="scope.row.state==='待审核'" size="mini" type="primary" @click="enableClick(scope.$index, scope.row)">同意</el-button>
                <el-button v-if="scope.row.state==='待审核'" size="mini" type="danger" @click="disableClick(scope.$index, scope.row)">拒绝</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='650px' center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">对账单编号：</span>
              <span>{{detailData.num}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">标题：</span>
              <span>{{detailData.title}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">对账时间：</span>
              <span>{{detailData.time}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">生成数量：</span>
                <span>{{detailData.number}}</span>
              </div>
              <div>
                <span class="span1">合计金额：</span>
                <span>{{detailData.total}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">开票数量：</span>
                <span>{{detailData.number2}}</span>
              </div>
              <div>
                <span class="span1">开票时间：</span>
                <span>{{detailData.time2}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">收款状态：</span>
                <span>{{detailData.state}}</span>
              </div>
              <div>
                <span class="span1">收款日期：</span>
                <span>{{detailData.date}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>委托车信息</span>
          </div>
          <div class="tableContainer">
            <el-table
              v-loading="tableLoad"
              :data="detailData.table"
              style="width: 100%"
              border
            >
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{scope.$index+1}}</div>
              </el-table-column>
              <el-table-column prop="batch" label="批次号" width="120" align="center"/>
              <el-table-column prop="num" label="运单编号" width="120" align="center"/>
              <el-table-column prop="bottom" label="底盘号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="type" label="型号" align="center"/>
              <el-table-column prop="start" label="起始方" align="center"/>
              <el-table-column prop="end" label="目的方" align="center"/>
              <el-table-column prop="date" label="发运日期" align="center"/>
              <el-table-column prop="date2" label="交车日期" align="center"/>
              <el-table-column prop="train" label="运输方式" align="center"/>
              <el-table-column prop="start2" label="起始城市" align="center"/>
              <el-table-column prop="end2" label="目的城市" align="center"/>
              <el-table-column prop="pay" label="托运金额" align="center"/>
            </el-table>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>审核信息</span>
          </div>
          <steps :step-data="stepData" :step-state="stepState"/>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>操作</span>
          </div>
          <div class="baseInfoContentItem">
            <div style="display: flex;margin:10px 20px 0 15px;">
              <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
              <el-input
                type="textarea"
                :style="'width:100%'"
                v-model="remark"
                placeholder="请填写同意/拒绝原因"
                autocomplete="off"
                size="small"
              />
            </div>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center">
          <el-button size="medium" type="primary" @click="agreeClick">同意</el-button>
          <el-button size="medium" type="danger" @click="refusedClick">拒绝</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="reasonTitle" :visible.sync="reasonVisible" width='550px' center :close-on-click-modal="false" top="30vh">
      <div class="reasonContainer">
        <div style="display: flex;padding-bottom: 20px;">
          <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
          <el-input
            type="textarea"
            style="width:100%;"
            v-model="reason"
            placeholder="请填写同意/拒绝原因"
            autocomplete="off"
            size="small"
          />
        </div>
        <div class="reasonBtn">
          <el-button size="medium" class="searchBtn" type="primary" @click="reasonClick">确认</el-button>
          <el-button size="medium" class="resetBtn" type="danger" @click="reasonVisible=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import steps from "@/components/steps";

export default {
  components: {
    steps,
  },
  data() {
    return {
      numIpt:'',
      titleIpt:'',
      timeIpt:'',
      auditTimeIpt:'',
      stateIpt:0,
      payStateIpt:0,
      stateOption:[
        {value:0,label:'全部',},
        {value:1,label:'待审核'},
        {value:2,label:'通过'},
        {value:3,label:'拒绝'},
      ],
      payStateOption:[
        {value:0,label:'全部',},
        {value:1,label:'已收款'},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[
        {num:'DZ202121512',title:'标题1',type:'收款',receipts:'委托商',total:'100',time:'2021-10-8 17:32:39',state:'待审核'},
        {num:'DZ202121512',title:'标题1',type:'收款',receipts:'港口',total:'200',time:'2021-10-8 17:32:39',state:'已通过'},
        {num:'DZ202121512',title:'标题1',type:'收款',receipts:'船舶',total:'300',time:'2021-10-8 17:32:39',state:'已拒绝'},
      ],
      detailDialogVisible:false,
      detailData:{
        num:'BH202151205',
        title:'标题1',
        time:'2021-10-8 14:28:03',
        number:'10辆',
        total:'200元',
        number2:'1',
        time2:'2021-10-8 17:58:28',
        state:'已收款',
        date:'2021-10-8',
        table:[
          {batch:'PC2120215251',num:'BH202151205',bottom:'DP201411',brand:'品牌1',type:'型号1',start:'委托商1',end:'经销商',date:'2021-9-28',date2:'2021-9-28',train:'公路',start2:'重庆市',end2:'重庆市',pay:'120',},
          {batch:'PC2120215251',num:'BH202151205',bottom:'DP201411',brand:'品牌1',type:'型号1',start:'委托商1',end:'经销商',date:'2021-9-28',date2:'2021-9-28',train:'公路',start2:'重庆市',end2:'重庆市',pay:'120',},
          {batch:'PC2120215251',num:'BH202151205',bottom:'DP201411',brand:'品牌1',type:'型号1',start:'委托商1',end:'经销商',date:'2021-9-28',date2:'2021-9-28',train:'公路',start2:'重庆市',end2:'重庆市',pay:'120',},
        ],
      },
      remark:'',
      stepData:[
        {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
        {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
        {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
      ],
      reasonVisible:false,
      reasonTitle:'',
      reason:'',
    };
  },
  computed:{
    stepState(){
      return function(state){
        switch(state) {
          case '':
            return 'wait'
          case 'success':
            return 'success'
          case 'failure':
            return 'error'
        }
      };
    },
  },
  methods: {
    refusedClick(){
      this.remark=this.remark.trim();
      if(!this.remark) return this.$message.warning('请填写拒绝理由！');
      this.detailDialogVisible=false;
    },
    agreeClick(){
      this.remark=this.remark.trim();
      if(!this.remark) return this.$message.warning('请填写同意理由！');
      this.detailDialogVisible=false;
    },
    contractSizeChange(sizes){
      this.size=sizes;
    },
    contractCurrentChange(page){
      this.page=page;
    },
    disableClick(){
      this.$confirm('确认拒绝当前委托商申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reason='';
        this.reasonTitle='拒绝原因';
        this.reasonVisible=true;
      }).catch(() => {});
    },
    detailClick(){
      this.remark='';
      this.detailDialogVisible=true;
    },
    searchBtn(){
      this.page = 1;
    },
    resetBtn(){
      this.numIpt='';
      this.titleIpt='';
      this.timeIpt='';
      this.auditTimeIpt='';
      this.stateIpt=0;
      this.payStateIpt=0;
    },
    enableClick(){
      this.$confirm('确认同意当前委托商申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reason='';
        this.reasonTitle='同意原因';
        this.reasonVisible=true;
      }).catch(() => {});
    },
    reasonClick(){
      this.reason=this.reason.trim();
      if(!this.reason) return this.$message.warning(this.reasonTitle==='同意原因'?'请填写同意原因！':'请填写拒绝原因!');
      this.reasonVisible=false;
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-badge__content{
          top: 4px !important;
          right: 1px !important;
        }
        .el-badge__content{
          background-color: #F56C6C !important;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
      .tableContainer{
        padding:10px 23px 10px 23px;
        ::v-deep{
          .el-table td, .el-table th{
            padding:0;
          }
          .cell{
            font-size: 10px;
            padding:0;
          }
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .reasonContainer{
    width:100%;
    padding: 20px 30px;
    ::v-deep{
      .el-textarea__inner{
        min-height: 100px!important;
      }
    }
    .reasonBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
